import { render, staticRenderFns } from "./StockAdjust.vue?vue&type=template&id=696aa52b&"
import script from "./StockAdjust.vue?vue&type=script&lang=js&"
export * from "./StockAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports